import React, { useEffect, useState, useContext } from 'react';
import { AppBar, Toolbar, Typography, Container, Button, Menu, MenuItem, IconButton } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { UserContext } from '../contexts/UserContext';
import { content } from '../api/client';

const Layout = ({ children }) => {
  const [modules, setModules] = useState([]);
  const [anchorElModule, setAnchorElModule] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const navigate = useNavigate();
  const { user, logout } = useContext(UserContext);

  useEffect(() => {
    content.modules()
      .then(({ data }) => setModules(data))
      .catch(() => setModules([]));
  }, []);

  const handleModuleClick = (event) => {
    setAnchorElModule(event.currentTarget);
  };

  const handleUserClick = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElModule(null);
    setAnchorElUser(null);
  };

  const handleModuleSelect = (id) => {
    navigate(`/module/${id}`);
    handleClose();
  };

  return (
    <>
      <AppBar position="static" color="primary">
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Code Hub
          </Typography>

          <Button color="inherit" component={Link} to="/">
            Modules
          </Button>

          <Button color="inherit" onClick={handleModuleClick} startIcon={<MenuIcon />}>
            Jump to Module
          </Button>
          <Menu anchorEl={anchorElModule} open={Boolean(anchorElModule)} onClose={handleClose}>
            {modules.map((mod) => (
              <MenuItem key={mod.id} onClick={() => handleModuleSelect(mod.id)}>
                {mod.title}
              </MenuItem>
            ))}
          </Menu>

          <Button color="inherit" component={Link} to="/editor?lang=python">
            Editor
          </Button>

          {user ? (
            <>
              <IconButton color="inherit" onClick={handleUserClick}>
                <span style={{ fontSize: '1.5rem' }}>{user.avatar || '👤'}</span>
              </IconButton>
              <Menu anchorEl={anchorElUser} open={Boolean(anchorElUser)} onClose={handleClose}>
                <MenuItem disabled>
                  <span style={{ fontSize: '1.2rem' }}>{user.avatar}</span> {user.username}
                </MenuItem>
                <MenuItem component={Link} to="/progress" onClick={handleClose}>
                  📊 Your Progress
                </MenuItem>
                <MenuItem component={Link} to="/profile" onClick={handleClose}>
                  🎨 Change Avatar
                </MenuItem>
                <MenuItem onClick={() => { logout(); handleClose(); }}>
                  🚪 Logout
                </MenuItem>
              </Menu>
            </>
          ) : (
            <>
              <Button color="inherit" component={Link} to="/login">
                Login
              </Button>
              <Button color="inherit" component={Link} to="/register">
                Register
              </Button>
            </>
          )}
        </Toolbar>
      </AppBar>

      <Container sx={{ mt: 4 }}>
        {children}
      </Container>
    </>
  );
};

export default Layout;
